import { render, staticRenderFns } from "./PEAsylumAssistant.vue?vue&type=template&id=5a3b1b1b&scoped=true&"
import script from "./PEAsylumAssistant.vue?vue&type=script&lang=js&"
export * from "./PEAsylumAssistant.vue?vue&type=script&lang=js&"
import style0 from "./PEAsylumAssistant.vue?vue&type=style&index=0&id=5a3b1b1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3b1b1b",
  null
  
)

export default component.exports